<template>
  <div class="standing">
    <div class="standing-bar">
      <search @searchFn="searchFn"></search>
      <el-row>
        <el-button size="small" icon="el-hg-icon-detail" @click="detail">详情</el-button>
        <el-button size="small" type="default" icon="el-hg-icon-add" @click="insert">新增</el-button>
        <el-button size="small" type="primary" icon="el-hg-icon-edit" @click="update">修改</el-button>
        <el-button size="small" type="danger" icon="el-hg-icon-delete" @click="adelete">删除</el-button>
        <el-button size="small" icon="el-hg-icon-start" @click="setAudit(1)">启用</el-button>
        <el-button size="small" icon="el-hg-icon-stop" @click="setAudit(-1)">停用</el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="refresh">刷新</el-button>
      </el-row>
    </div>
    <!-- list view -->
    <div v-loading="loading" class="standing-list">
      <list class="list" :data-list.sync="aDataList" @detail="detail" ref="tableList" />
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currentPage" :page-sizes="queryParams.pageSizes" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>

    <!-- dialogs -->
    <my-dialog :id="currentId" :dialog-type.sync="dialogType" :show="bShowDialog" @close="closeDialog" @refresh="refresh" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ZycComm from '@/mixins/comm.mixin';
import Search from './search';
import List from './list';
import MyDialog from './dialog';


export default {
  name: 'timeWork',
  components: {
    Search,
    List,
    MyDialog
  },
  data() {
    return {
      aDataList: [],
      total: 0,
      queryParams: {
        pageSizes: [10, 20, 50, 100],
        pageSize: 10,
        currentPage: 1,
        taskType: 'system',
        userId: '',
        depCode: ''
      }
    };
  },
  mixins: [ZycComm],
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor'
    })
  },
  methods: {
    /**
     * list 台账
     */
    async getList() {
      this.startLoading();
      const { bean } = await this.$services.post({
        type: 'TIMEWORK',
        url: 'getList',
        params: this.queryParams
      });

      for (let i = 0; i < bean.list.length; i++) {
        let item = bean.list[i];
        item.checked = false;
        item.index = bean.pageSize * (bean.pageNum - 1) + (i + 1);
      }
      this.aDataList = bean.list;
      this.total = bean.total;
      this.stopLoading();
    },
    /**
     * 删除
     */
    async deleteFn(ids) {
      const { status } = await this.$services.post({
        type: 'TIMEWORK',
        url: 'deleteFn',
        params: {
          ids: JSON.stringify(ids)
        }
      });

      if (status) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.refresh();
      }
      else {
        this.$message({
          type: 'error',
          message: '删除失败!'
        });
      }
    },
    /**
     * ids
     * flag = 1：启用，-1：停用;
     */
    async startUse(ids, flag) {
      const { status } = await this.$services.post({
        type: 'TIMEWORK',
        url: 'startUse',
        params: {
          ids: JSON.stringify(ids),
          state: flag
        }
      });
      if (status) {
        this.$message({
          message: flag === 1 ? '启用成功' : '停用成功',
          type: 'success'
        });
        this.refresh();
      }
      else {
        this.$message({
          message: flag === 1 ? '启用失败' : '停用失败',
          type: 'danger'
        });
      }
    },
    /**
     * 启用，停用
     */
    setAudit(flag) {
      // let flag = 1：启用，-1：停用;
      let textInfo = [];
      let ids = [];
      let state = flag === 1 ? '-1' : '1';
      for (let i = 0; i < this.aDataList.length; i++) {
        let item = this.aDataList[i];

        if (item.checked && item.state === state) {
          ids.push({
            value: item.id
          });
          textInfo.push(item.taskName);
        }
      }
      if (ids.length === 0) {
        this.$message({
          message: flag === 1 ? '请选择一条或多条 停用 的列' : '请选择一条或多条已 启用 的数据',
          type: 'info'
        });
        return;
      }

      this.$confirm(
        `此操作将${flag === 1 ? '启用' : '停用'}<span style="color:red;padding:0 4px;"> ${textInfo.join(
          ','
        )} </span>, 是否继续?`,
        '提示',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.startUse(ids, flag);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    searchFn(param) {
      Object.assign(this.queryParams, param);
      this.getList();
    },
    adelete() {
      // this.bDeleteShowDialog = true;
      let ids = [];
      let textInfo = [];
      for (let i = 0; i < this.aDataList.length; i++) {
        let item = this.aDataList[i];
        if (item.checked) {
          ids.push({
            value: item.id
          });
          textInfo.push(item.taskName);
        }
      }
      if (ids.length > 0) {
        this.$confirm(
          `此操作将永久删除数据<span style="color:red;padding:0 4px;"> ${textInfo.join(
            ','
          )} </span>, 是否继续?`,
          '提示',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.deleteFn(ids);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      }
      else {
        this.$message({
          type: 'info',
          message: '请选择一条或多条数据！'
        });
      }
    },
    refresh() {
      this.closeDialog();
      this.getList();
    }
  },
  created() {
    this.queryParams.userId = this.userInfor.id;
    this.queryParams.depCode = this.userInfor.depCode;
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.pagination-box {
  text-align: center;
}
</style>
